type ClipboardResult = "success" | "fallback" | "failed";

export async function copyToClipboard(text: string): Promise<ClipboardResult> {
  if (typeof document === "undefined") return "failed";

  if (
    typeof navigator !== "undefined" &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function" &&
    window.isSecureContext !== false
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return "success";
    // intentional: navigator.clipboard rejected (iOS Safari, http://, permission denied) — fall through to execCommand fallback
    } catch {
      // fall through to execCommand fallback (iOS Safari, http://, permission denied)
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.width = "1px";
    textarea.style.height = "1px";
    textarea.style.padding = "0";
    textarea.style.border = "none";
    textarea.style.outline = "none";
    textarea.style.boxShadow = "none";
    textarea.style.background = "transparent";
    textarea.style.opacity = "0";
    textarea.style.pointerEvents = "none";
    document.body.appendChild(textarea);

    const selection = document.getSelection();
    const prevRange =
      selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

    textarea.focus({ preventScroll: true });
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    const ok = document.execCommand("copy");

    textarea.remove();
    if (prevRange && selection) {
      selection.removeAllRanges();
      selection.addRange(prevRange);
    }

    return ok ? "fallback" : "failed";
  } catch {
    return "failed";
  }
}
